﻿import { KbVector } from '@kb3d/models/classes/primitives/kb-vector';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { IHemisphericLightNode } from '../kb3d-models';
import { KbColor } from '../primitives/kb-color';
import { Token } from '../token';
import { LightNode } from './light-node';

@Kb3dModel({
    token: Token.HemisphericLightNode,
})
export class HemisphericLightNode extends LightNode implements IHemisphericLightNode {
    constructor() {
        super();
    }
    public direction: KbVector;
    public groundColor: KbColor;
}
